<template>
  <div class="solutions__list">
    <slot name="products" :view="view" :moduleCatalog="moduleCatalog"></slot>
    <product-card-solutions v-for="(item, key) in moduleCatalog.products" :info="item" :key="item.ID" :number="key">
      <template v-slot:product="productSlotProps">
        <a class="solutions-card__img" :href="productSlotProps.info.DETAIL_PAGE_URL">
          <div class="solutions-card__slider swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(image, imageKey)  in productSlotProps.info.IMAGES" :key="imageKey">
                <div class="solutions-card__img-img">
                  <picture>
                    <source :srcset="image.PICTURE ? image.PICTURE : ''"
                            type="image/webp">
                    <img :src="image.PICTURE ? image.PICTURE : ''"
                         :alt="productSlotProps.info.IMG_DESCRIPTION"
                         loading="lazy">
                  </picture>
                </div>
              </div>

              <div class="swiper-slide" v-if="!productSlotProps.info.IMAGES">
                <div class="solutions-card__img-img">
                  <img src="/local/templates/xpage/img/catalog/product.svg" alt="Заглушка товара" loading="lazy">
                </div>
              </div>
            </div>
            <div class="swiper-pagination solutions-card__pagination"></div>
            <div class="solutions-card__nav">
              <span class="solutions-card__nav-item"
                 v-for="(image, key) in productSlotProps.info.IMAGES"
                 :key="key"></span>

              <span class="solutions-card__nav-item"
                 v-if="!productSlotProps.info.IMAGES"></span>
            </div>
          </div>
        </a>
        <a class="solutions-card__name icon-link icon-link--base"
           :href="productSlotProps.info.DETAIL_PAGE_URL"><span>{{ productSlotProps.info.NAME }}</span>
          <svg class="icon-link__icon" aria-hidden="true">
            <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
          </svg>
        </a>
      </template>
    </product-card-solutions>
  </div>
  <slot v-if="!all" name="pagination" :loadMore="loadMore"></slot>
</template>

<script>
import {mapState, mapActions} from "vuex";
import ProductCardSolutions from "./ProductCardSolutions.vue";

export default {
  name: "ProductListStock",
  components: {ProductCardSolutions},
  props: {
    pages: Number,
    view: Number,
    sort: Number,
    sort_by: String,
    sort_order: String,
    section: Number,
    count: Number,
    nav_num: Number,
    filter: [Array, Object],
    items: Array
  },
  data() {
    return {
      page: 2,
      all: false,
      itemQuantity: 0
    };
  },
  computed: {
    ...mapState([
      "moduleCatalog"
    ])
  },
  methods: {
    ...mapActions([
      "SET_PRODUCTS"
    ]),
    loadMore() {
      if (this.all) return;
      let query = (document.location.search === "" ? "?" : "&") + "pagination=Y&PAGEN_" + this.nav_num + "=" + this.page;
      fetch(document.location.href + query, {
        method: "GET"
      })
          .then(response => response.json())
          .then(result => {
            if (result.data.length > 0) {
              this.SET_PRODUCTS(result.data);
            }
            this.page++;
            if (this.pages < this.page) {
              this.all = true;
            }
          });
    }
  },
  created() {
    this.all = this.pages < this.page;
  }
};
</script>